<script setup>
import { inject, ref } from 'vue'
import LibraryBooksAll from './LibraryBooksAll.vue'
import LibraryBooksPersonal from './LibraryBooksPersonal.vue'

const activeTab = ref('toate-cartile')
const dataset = inject('dataset')

const checkLogin = (event) => {
  if (event == 'cartile-mele' && !dataset.user) {
    document.forms.auth.action += '&next=' + window.location.href
    document.forms.auth.submit()
  }
}
</script>

<template>
  <div>
    <div class="container is-widescreen">
      <section class="section has-tabs">
        <b-tabs
          v-model="activeTab"
          :animated="false"
          type="is-toggle"
          class="is-offset"
          @update:modelValue="checkLogin"
        >
          <b-tab-item label="Toate cărțile" value="toate-cartile">
            <library-books-all v-if="activeTab == 'toate-cartile'" />
          </b-tab-item>

          <b-tab-item label="Cărțile mele" value="cartile-mele">
            <library-books-personal
              v-if="activeTab == 'cartile-mele' && dataset.user"
            />
          </b-tab-item>
        </b-tabs>
      </section>
    </div>
  </div>
</template>
